import type { ComponentProps, PropsWithChildren } from 'react';
import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

type Props = Readonly<{
	onClick?: () => void;
}> &
	ComponentProps<typeof Button>;

export const LoadMoreButton = (({ children, onClick, ref, ...rest }) => {
	return (
		<Button variant="secondary" onClick={onClick} ref={ref} {...rest}>
			{children}
		</Button>
	);
}) as React.FC<
	PropsWithChildren<Props> & {
		ref?: React.RefObject<HTMLButtonElement | null>;
	}
>;
